import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    paperTypeListLoading: false,
    paperTypeListSuccess: null,
    paperTypeListError: '',

    getPaperTypeLoading: false,
    getPaperTypeSuccess: null,
    getPaperTypeError: '',

    createPaperTypeLoading: false,
    createPaperTypeSuccess: {},
    createPaperTypeError: '',
}

export const paperTypeSlice = createSlice({
    name: 'paperType',
    initialState, 
    reducers: {
        setPaperTypeListLoading: (state) => {
            state.paperTypeListLoading = true;
            state.paperTypeListSuccess = null;
            state.paperTypeListError = '';
        },
        setPaperTypeListSuccess: (state, action) => {
            state.paperTypeListLoading = false;
            state.paperTypeListSuccess = action.payload;
            state.paperTypeListError = '';
        },
        setPaperTypeListError: (state, action) => {
            state.paperTypeListLoading = false;
            state.paperTypeListSuccess = null;
            state.paperTypeListError = action.payload;
        },
        setGetPaperTypeLoading: (state) => {
            state.getPaperTypeLoading = true;
            state.getPaperTypeSuccess = {};
            state.getPaperTypeError = '';
        },
        setGetPaperTypeSuccess: (state, action) => {
            state.getPaperTypeLoading = false;
            state.getPaperTypeSuccess = action.payload;
            state.getPaperTypeError = '';
        },
        setGetPaperTypeError: (state, action) => {
            state.getPaperTypeLoading = false;
            state.getPaperTypeSuccess = {};
            state.getPaperTypeError = action.payload;
        },
        setCreatePaperTypeLoading: (state) => {
            state.createPaperTypeLoading = true;
            state.createPaperTypeSuccess = {};
            state.createPaperTypeError = '';
        },
        setCreatePaperTypeSuccess: (state, action) => {
            state.createPaperTypeLoading = false;
            state.createPaperTypeSuccess = action.payload;
            state.createPaperTypeError = '';
        },
        setCreatePaperTypeError: (state, action) => {
            state.createPaperTypeLoading = false;
            state.createPaperTypeSuccess = {};
            state.createPaperTypeError = action.payload;
        },
        resetDetails: (state) => {
            state.getPaperTypeSuccess = {};
            state.createPaperTypeSuccess = {};
        },
    }
})

export const { setPaperTypeListLoading, setPaperTypeListSuccess, setPaperTypeListError,
    setGetPaperTypeLoading, setGetPaperTypeSuccess, setGetPaperTypeError, 
    setCreatePaperTypeLoading, setCreatePaperTypeSuccess, setCreatePaperTypeError,
    resetDetails
} = paperTypeSlice.actions;


export default paperTypeSlice.reducer;